import { translate } from '@core/i18n/window-language';
import {
    BOUND_POSITION_ATTRIBUTE,
    BOUND_POSITIONS,
    TOOLTIP_POSITION,
} from '@components/TooltipComponent/CONSTANTS';

/**
 * Update tooltip content with translated text
 * @param {HTMLParagraphElement} tooltipElement - The tooltip text element
 * @returns {void}
 */
export function updateTooltipContent(tooltipElement) {
    if (!tooltipElement) return;
    tooltipElement.innerText = translate('tooltip.generativeAI');
}

/**
 * Apply tooltip positioning based on position and flex grow values
 * @param {HTMLElement} tooltipContainer - The tooltip container element
 * @param {string} tooltipPosition - The tooltip position
 * @param {number} customFlexGrow - The custom flex grow value
 * @returns {void}
 */
export function applyTooltipPositioning(
    tooltipContainer,
    tooltipPosition,
    customFlexGrow,
) {
    if (!tooltipContainer) return;

    switch (tooltipPosition) {
        case TOOLTIP_POSITION.BOTTOM_RIGHT:
            tooltipContainer.style.right = `${Math.min(customFlexGrow * 0.5, 40)}%`;
            break;
        case TOOLTIP_POSITION.BOTTOM_LEFT:
            tooltipContainer.style.left = `${Math.min(customFlexGrow * 0.5, 40)}%`;
            tooltipContainer.style.right = 'unset';
            break;
        case TOOLTIP_POSITION.TOP_LEFT:
            tooltipContainer.style.right = '45px';
            tooltipContainer.style.setProperty('top', '0', 'important');
            break;
        case TOOLTIP_POSITION.TOP_RIGHT:
            tooltipContainer.style.right = 'unset';
            tooltipContainer.style.left = '45px';
            tooltipContainer.style.setProperty('top', '0', 'important');
            tooltipContainer.setAttribute(
                BOUND_POSITION_ATTRIBUTE,
                BOUND_POSITIONS.RIGHT,
            );
            break;
        default:
            break;
    }
}

/**
 * Apply tooltip content width styling
 * @param {HTMLElement} tooltipContent - The tooltip content element
 * @param {number} tooltipContentWidth - The width to apply
 * @returns {void}
 */
export function applyTooltipContentWidth(tooltipContent, tooltipContentWidth) {
    if (!tooltipContent || !tooltipContentWidth) return;
    tooltipContent.style.maxWidth = `${tooltipContentWidth}px`;
}
